import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RouteStateService {
  private pathParamsState = new BehaviorSubject<Record<string, string>>({});

  get params() {
    return this.pathParamsState.value;
  }

  get params$() {
    return this.pathParamsState.asObservable();
  }

  updateParams(params: Record<string, string>) {
    this.pathParamsState.next({ ...this.pathParamsState.value, ...params });
  }
}
